import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import Link from 'next/link';
import Router from 'next/router';

import Navbar from '../components/Navbar';

@inject('stores')
@observer
class MoreInfo extends Component {
  componentDidMount() {
    const { slug } = Router.router.query;
    this.props.stores.blogStore.show(slug);
  }

  render() {
    const { post } = this.props.stores.blogStore;

    if (!post || !post.title) {
      return <div />;
    }

    const footerLink = () => {
      if (post.slug === 'parents') {
        return (
          <Link href="/products?category=237">
            <a className="btn btn-pink">Subscribe today</a>
          </Link>
        );
      }

      if (post.slug === 'schools') {
        return (
          <Link href="/contact">
            <a className="btn btn-pink">Contact us</a>
          </Link>
        );
      }

      return '';
    };

    return (
      <main className="page-more-info">
        <Navbar logoType="white" />
        <div className="content container">
          {post.slug === 'how-it-works' ? (
            <Link href="/education">
              <a className="back-button">&#8592; Go back</a>
            </Link>
          ) : (
            <Link href="/more-info/how-it-works">
              <a className="back-button">&#8592; Back to MORE INFO</a>
            </Link>
          )}
          <div
            className="content-navigation"
            style={
              post.slug === 'how-it-works'
                ? { display: 'block' }
                : { display: 'none' }
            }
          >
            <p className="bullet">I want to learn more about</p>
            <div className="buttons-container">
              <div className="button-wrapper">
                <Link href="/more-info/business">
                  <a className="more-info-navigation">
                    <span>Business</span>
                  </a>
                </Link>
              </div>
              <div className="button-wrapper">
                <Link href="/more-info/parents">
                  <a className="more-info-navigation">
                    <span>Parents & Grandparents</span>
                  </a>
                </Link>
              </div>
              <div className="button-wrapper">
                <Link href="/more-info/schools">
                  <a className="more-info-navigation">
                    <span>Schools</span>
                  </a>
                </Link>
              </div>
              <div className="button-wrapper">
                <Link href="/more-info/foundation">
                  <a className="more-info-navigation">
                    <span>Our foundation</span>
                  </a>
                </Link>
              </div>
            </div>
          </div>
          <div className="content-body">
            <h1
              style={
                post.slug === 'how-it-works'
                  ? { display: 'block' }
                  : { display: 'none' }
              }
            >
              {post.title.rendered}
            </h1>
            <div dangerouslySetInnerHTML={{ __html: post.content.rendered }} />
            {footerLink()}
          </div>
        </div>
      </main>
    );
  }
}

export default MoreInfo;
